import { getApiUrl, JOB_API_URL } from '../../util/api/api'
import type { JobContent } from '../../../state/reducers/jobs/jobs'
import { StatusCodes } from 'http-status-codes'

type Args = {
  id: string,
  jobContent: JobContent,
}

const updateJob = async ({ id, jobContent }: Args): Promise<any> => {
  const fetchResponse = await fetch(
    getApiUrl(`${JOB_API_URL}/${id}/update`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(jobContent),
    }
  )

  if (fetchResponse?.ok) {
    return Promise.resolve({ status: StatusCodes.ACCEPTED })
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}

export default updateJob
